import { webEnv } from "@/config/webEnv";
import { useRedeemPointsLinkBase } from "@roman/shared/hooks/useRedeemPointsLinkBase";
import type { UseRedeemPointsLinkInput } from "@roman/shared/hooks/useRedeemPointsLinkBase";
import { getPlatform } from "@roman/shared/utils/platform";
import { useLocation, useNavigate } from "react-router-dom";

export const useRedeemPointsLink = (input: UseRedeemPointsLinkInput) => {
  const _navigate = useNavigate();
  const location = useLocation();
  const navigate = (path: string) => _navigate(path, { state: { from: location.pathname } });
  const env = webEnv.DEV ? "dev" : "prod";
  const platform = getPlatform();
  const openBrowser = (url: string) => window.open(url, "_blank");

  const { onClick } = useRedeemPointsLinkBase(input, env, platform, navigate, openBrowser);
  return { onClick };
};
